export class CheckTokenReturn {
    isValid: boolean;
    ErrorMessage?: string;
    Url?: string;
    CompanyCode: string;
    LabelFileName: string;

    constructor(isValid: boolean, errorMessage?: string, url?: string, companyCode: string = '', labelFileName: string = '') {
        this.isValid = isValid;
        this.ErrorMessage = errorMessage;
        this.Url = url;
        this.CompanyCode = companyCode;
        this.LabelFileName = labelFileName;
    }
}
